module.exports = __webpack_public_path__ + "4c152013b336092cc0be1c92876c7f12.svg";